import { Component, Input } from '@angular/core';
import {
  ACTION_ICON_PATHS,
  type ActionIconName,
  type IconButtonDensity,
} from './action-icon';

@Component({
  selector: 'app-action-icon',
  template: `
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path [attr.d]="path"></path>
    </svg>
  `,
  styleUrls: ['./action-icon.component.scss'],
  host: {
    '[class.tt-action-icon--toolbar]': 'density === "toolbar"',
    '[class.tt-action-icon--row]': 'density === "row"',
  },
})
export class ActionIconComponent {
  @Input() name: ActionIconName = 'edit';
  /** Empty follows context: toolbar in the page header, compact everywhere else. */
  @Input() density: IconButtonDensity = '';

  get path(): string {
    return ACTION_ICON_PATHS[this.name] ?? ACTION_ICON_PATHS.edit;
  }
}
